import { dropRight, isArray } from "lodash";

const supportedLanguages = ["en", "zh"];

export const detectLanguage = (props) => {
  const urlLang = props.history.location.pathname.split("/")[3];
  const userLanguage = window.navigator.language.slice(0, 2);
  if (supportedLanguages.includes(urlLang)) {
    return { needRedirect: false, language: urlLang };
  } else if (supportedLanguages.includes(userLanguage)) {
    return { needRedirect: true, language: userLanguage };
  } else {
    return { needRedirect: true, language: userLanguage };
  }
};

export const setFirstLetterToUpperCase = (lang) => {
  if (lang) {
    return lang.charAt(0).toUpperCase() + lang.slice(1);
  } else {
    return "En";
  }
};

export const constructParams = (params) => {
  let query = ``;
  if (params) {
    Object.entries(params).forEach(([key, value], index) => {
      if (isArray(value) && value.length > 0) {
        value.map((ele, valIndex) => {
          if (index == 0 && valIndex == 0) {
            query += `${key}=${ele}`;
          } else {
            query += `&${key}=${ele}`;
          }
        });
      } else {
        if (index == 0) {
          query += `${key}=${value}`;
        } else {
          query += `&${key}=${value}`;
        }
      }
    });
  }
  return query;
};

export const langStringConvertor = (language) => {
  if (language === "zh") {
    return "tc";
  } else if (language === "cn") {
    return "sc";
  } else {
    return "en";
  }
};

export const vehicleIconBg = () => {
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    scale: 14,
    fillOpacity: 1,
    zIndex: "501",
    fillColor: "#3499FE",
    strokeColor: "#1A73E8",
    strokeWeight: 2,
  };
};

export const vehicleIconCar = () => {
  return {
    path: "m -4.86 -8.66 l 9.72 0 c 1.62 0 2.43 0.81 2.43 2.43 l 0 8.1 l 0 2.43 c 0 1.62 -1.62 1.62 -2.43 1.62 l 0 0.81 c 0 0.81 0 0.81 -0.81 0.81 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -1.62 l -4.86 0 c 0 1.62 0 1.62 -0.81 1.62 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -0.81 l 0 -0.81 c -0.81 0 -2.43 0 -2.43 -1.62 l 0 -0.81 l 0 -1.62 l 0 -8.1 c 0 -1.62 0.81 -2.43 2.43 -2.43 m -0.81 2.43 l 0 4.86 c 4.05 0.81 7.29 0.81 11.34 0 c 0 -1.62 0 -3.24 0 -4.86 c -0.81 -0.81 -10.53 -0.81 -11.34 0 M -6 3 C -6 5 -2 5 -2 2 C -3 2 -6 1 -6 3 M 2 2 C 2 5 6 5 6 3 C 6 1 3 2 2 2",
    scale: 1,
    fillOpacity: 1,
    fillColor: "#FFF",
    strokeWeight: 0,
    zIndex: "502",
  };
};

/**
 * 
 * @param {string} hideStop the stragegy
 */
export const hideStopDroppingStragegy = (hideStop) => {
  if (hideStop === 'tailStops') {
    /**
     * @param {any[]} stops
     */
    return (stops) => {
      return dropRight(stops)
    }
  }

  /**
   * @param {any[]} stops
   */
  return (stops) => stops
}